import React, { useState } from 'react';

import { ModalComponent } from 'components';
import { useAppSelector } from 'stores';
import { IStickerListItem } from 'types';
import GroupGrant from './GroupGrant';
import UserGrant from './UserGrant';
import * as S from './style';

type TabType = 'USER' | 'GROUP';

interface Props {
  sticker: IStickerListItem;
  onClose: () => void;
}

function GrantSheet({ sticker, onClose }: Props) {
  const permissions = useAppSelector((s) => s.auth.user?.permissions ?? []);
  const canUseGroup = permissions.includes('user_group:list');
  const [tab, setTab] = useState<TabType>('USER');

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal
          title={`${sticker.name} 지급`}
          handleClose={onClose}
          footer={<></>}
        >
          <div css={S.sheet}>
            {canUseGroup && (
              <div css={S.tabs}>
                <button
                  type="button"
                  css={S.tab(tab === 'USER')}
                  onClick={() => setTab('USER')}
                >
                  회원 검색
                </button>
                <button
                  type="button"
                  css={S.tab(tab === 'GROUP')}
                  onClick={() => setTab('GROUP')}
                >
                  회원 그룹
                </button>
              </div>
            )}
            {tab === 'USER' ? (
              <UserGrant sticker={sticker} />
            ) : (
              <GroupGrant sticker={sticker} />
            )}
          </div>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default GrantSheet;
